// app/features/user-profile/services_and_hooks/useUserProfileQueryHook.ts
import { useQuery } from '@tanstack/react-query';

import { useDataFetchingHook } from '@/app/shared/hooks/useDataFetchingHook';

import { userProfileService } from './userProfileService';

export function useUserProfileQueryHook(userId: string | null, orgId: string | null) {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['user-profile', userId, orgId],
    queryFn: () => {
      if (!userId || !orgId) throw new Error('User ID and Organization ID are required');
      return userProfileService.getUserProfile(userId, orgId);
    },
    enabled: !!userId && !!orgId,
    staleTime: 30 * 1000, // 30 seconds
  });

  useDataFetchingHook({ 
    isLoading, 
    isError, 
    error, 
    errorMessage: error?.message || 'Failed to load user profile'
  });

  return {
    userProfile: data,
    isLoading,
    isError,
    error,
    refetch
  };
}

